import React from 'react';
import type { LabelProps } from './types';

export const Label: React.FC<LabelProps> = ({ htmlFor, children }) => (
    <label htmlFor={htmlFor} className="text-compact font-medium text-primary-1100">
        {children}
    </label>
);
